import { getTokenClaims as decodeJwtClaims } from "./jwt";

export const getToken = () => localStorage.getItem("token");

export const getRole = () => localStorage.getItem("role");

export const getIsSubscribed = (): boolean => {
  const v = localStorage.getItem("isSubscribed");
  return v === "true";
};

/** True when the logged-in user still has to complete the first-login password change. */
export const getMustChangePassword = (): boolean => {
  const claims = getTokenClaims();
  return claims?.mustChangePassword === true;
};

export const getTokenClaims = () => {
  const token = getToken();
  if (!token) return null;
  return decodeJwtClaims(token);
};

export const saveAuth = (token: string, role: string, isSubscribed?: boolean) => {
  localStorage.setItem("token", token);
  localStorage.setItem("role", role);
  if (isSubscribed !== undefined) {
    localStorage.setItem("isSubscribed", String(isSubscribed));
  }
};

export const clearAuth = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("isSubscribed");
};
